export type AipProductSeoKey =
  | 'finance'
  | 'manufacturing'
  | 'production-planning'
  | 'retail'
  | 'project-management'
  | 'supply-chain'
  | 'srm'
  | 'crm'
  | 'ecommerce'
  | 'hcm';

export type AipSolutionSeoKey = 'supply-chain-planning' | 'procurement-and-sales' | 'procurement';

export type AipSeoTdk = {
  title: string;
  description: string;
  keywords: string;
};

export const AIP_PRODUCT_SEO_TDK: Record<AipProductSeoKey, AipSeoTdk> = {
  srm: {
    title: '供应商关系SRM业务应用-端点科技',
    description:
      '端点供应商关系SRM业务应用覆盖寻源、协同、评估、优化等供应商全生命周期管理，帮助企业提升采购协作效率、供应商绩效管理能力与供应链韧性。',
    keywords: '供应商关系,SRM,供应商管理,寻源管理,供应商协同,供应商评估,采购协同,供应链韧性,端点科技'
  },
  'supply-chain': {
    title: '供应链业务应用-端点科技',
    description:
      '端点供应链业务应用打通采购、销售、库存、仓库、送装与运输等核心环节，帮助企业实现供应链可视、可控、可预测，提升订单交付与运营效率。',
    keywords: '供应链,供应链管理,采购管理,销售管理,库存管理,仓库管理,运输管理,供应链协同,端点科技'
  },
  crm: {
    title: '客户关系CRM业务应用-端点科技',
    description:
      '端点客户关系CRM业务应用以销售自动化为核心，覆盖客户管理、渠道商管理、线索商机与回款协同，帮助企业提升客户粘性、复购率与销售增长能力。',
    keywords: '客户关系,CRM,销售自动化,SFA,客户管理,渠道商管理,商机管理,销售管理,端点科技'
  },
  ecommerce: {
    title: '商城业务应用-端点科技',
    description:
      '端点商城业务应用支持采购商城、销售商城及多交易场景建设，通过统一后台和多端适配能力，帮助企业搭建灵活、可扩展的数字化交易门户。',
    keywords: '商城,电商系统,采购商城,销售商城,B2B商城,B2C商城,数字化交易,订单管理,端点科技'
  },
  retail: {
    title: '零售业务应用-端点科技',
    description:
      '端点零售业务应用面向全渠道零售场景，覆盖促销、会员、门店管理与库存协同，帮助企业实现一盘货全渠道运营，提升周转效率与客户体验。',
    keywords: '零售,智慧零售,全渠道零售,会员管理,促销管理,门店管理,库存协同,零售数字化,端点科技'
  },
  'production-planning': {
    title: '计划业务应用-端点科技',
    description:
      '端点计划业务应用覆盖销售与运营计划、物料需求计划、主生产计划和高级计划排程，帮助企业构建从需求到交付的统一计划体系，提升计划可执行性。',
    keywords: '计划管理,生产计划,S&OP,物料需求计划,MRP,主生产计划,MPS,高级计划排程,APS,端点科技'
  },
  manufacturing: {
    title: '生产业务应用-端点科技',
    description:
      '端点生产业务应用围绕生产执行全过程，覆盖生产、质量与工厂维护等场景，通过工程数据标准化、过程可视化与执行闭环管理，提升生产效率与交付能力。',
    keywords: '生产管理,制造管理,MES,质量管理,工厂维护,生产执行,生产可视化,智能制造,端点科技'
  },
  'project-management': {
    title: '项目管理业务应用-端点科技',
    description:
      '端点项目管理业务应用覆盖项目立项、进度、资源、任务、成本与结算等全生命周期管理，融合业财一体化与跨部门协同，提升项目交付质量与风险管控能力。',
    keywords: '项目管理,项目进度管理,资源管理,任务管理,项目交付,业财一体化,成本管控,项目风险预警,端点科技'
  },
  finance: {
    title: '财务业务应用-端点科技',
    description:
      '端点财务业务应用覆盖业财、管理会计与财务会计，打通业务与财务数据，提升多组织财务标准化、自动化与经营分析能力，让业务决策更有据可依。',
    keywords: '财务管理,业财一体化,管理会计,财务会计,财务数字化,经营分析,财务自动化,企业财务系统,端点科技'
  },
  hcm: {
    title: '人力HCM业务应用-端点科技',
    description:
      '端点人力HCM业务应用覆盖核心人事、招聘、薪酬与绩效管理，依托AI能力重构人力资源运营，实现员工全生命周期管理、合规风控与人才发展。',
    keywords: '人力资源管理,HCM,核心人事,招聘管理,薪酬管理,绩效管理,员工生命周期,AI人力资源,端点科技'
  }
};

export const AIP_SOLUTION_SEO_TDK: Record<AipSolutionSeoKey, AipSeoTdk> = {
  procurement: {
    title: '数智化采购解决方案-端点科技',
    description:
      '端点企业数智化采购解决方案面向中大型企业，覆盖生产性采购、非生产性采购、供应商协同、采购流程管理与AI风险预警，帮助企业提升采购效率、优化成本、强化合规管控。',
    keywords:
      '数智化采购,企业采购管理,采购数字化,供应商协同,采购管理系统,采购降本,生产性采购,MRO采购,AI采购,端点科技'
  },
  'procurement-and-sales': {
    title: '采销协同解决方案-端点科技',
    description:
      '端点采销协同解决方案覆盖采购、销售、库存、财务等核心业务，以主数据贯通、流程协同、风控前置和业财一体化为核心，帮助企业打通上下游协同链路，实现效率提升与经营增长。',
    keywords:
      '采销协同,采购销售协同,供应链协同,业财一体化,库存管理,销售协同,采购协同,企业协同平台,供应链数字化,端点科技'
  },
  'supply-chain-planning': {
    title: '智慧供应链计划解决方案-端点科技',
    description:
      '端点企业智慧供应链计划解决方案构建端到端计划体系，覆盖S&OP、需求计划、供应计划、库存优化与AI智能决策，帮助大型企业降低供应链成本、缩短交付周期、提升运营韧性。',
    keywords:
      '智慧供应链计划,供应链计划,S&OP,需求计划,供应计划,库存优化,供应链数字化,APS,MRP,AI供应链,端点科技'
  }
};
